import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import useUI from 'src/hooks/use-ui';
import _ from 'lodash';
import { useKioskPro } from 'src/hooks/use-kiosk-pro';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useMenuFilterOptions from 'hooks/use-menu-filter-options';

import { FullPageLoader } from 'shared/components';
import Menu from 'components/menu';
import { BrandsGrid } from 'components/brands-grid';
import { AmplitudeEvents, useAmplitude } from 'shared/hooks/use-amplitude';
import useStores from 'shared/hooks/use-stores';
import { useGetProductsByBrand } from 'src/dispensary/hooks/use-get-products-by-brand';

export default function CoreMenuBrandsPage() {
  const { dispensary } = useDispensary();
  const { query } = useRouter();
  const { isKiosk } = useUI();
  const isKioskProEnabled = useKioskPro();

  // Get brands data for the grid
  const {
    brands,
    apolloValues: { loading: loadingFilters },
  } = useMenuFilterOptions({ skipCurrentFilters: true });

  // Get products data when viewing a specific brand
  const { products, loading, totalCount, totalPages } = useGetProductsByBrand(query?.brandId);

  const amplitude = useAmplitude();
  const { UI } = useStores();

  useEffect(() => {
    if (!_.isEmpty(dispensary?.id)) {
      amplitude.log(AmplitudeEvents.menu.viewBrand, {
        dispensaryId: dispensary?.id,
        dispensaryName: dispensary?.name,
        menuVariant: UI.analyticsMenuVariant,
      });
    }
    // rationale: exhaustive deps cause these events to be fired more than we want
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispensary?.id]);

  if (!dispensary) {
    return null;
  }

  // Show brands grid when no specific brand is selected
  if (!query?.brandId) {
    return loadingFilters ? <FullPageLoader /> : <BrandsGrid brands={brands} />;
  }

  // Show products for the selected brand
  return (
    <Menu
      products={products}
      loading={loading}
      dispensary={dispensary}
      totalCount={totalCount}
      totalPages={totalPages}
      page='brands'
      displaySidebar={!isKioskProEnabled || !isKiosk}
    />
  );
}
